import { BomDto } from "src/dtos/bom/BomDto";
import { SalesDto } from "src/dtos/sales/salesBillDto";
import { SalOrderDtlDto } from "src/dtos/salorder/salOrderDto";
import { formatDate } from "src/utils/string/stringUtil";


export interface PUR1021_R01Dto {


}

export interface PUR1021_R01HeaderDto extends SalOrderDtlDto {
	salesOrderItemNo: string; // 수주항목번호 - 테이블식별용
}

export const defaultPUR1021_R01HeaderDto: PUR1021_R01HeaderDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,

	salesOrderItemNo: '',
	salesOrderNo: '',
	itemNo: '',
	compCd: '',
	logicCenter: '',  
	orderDt: formatDate(new Date()),
	customCd: '',
	customNm: '',
	itemSeq: 0,
	itemCd: '',
	orderUnit: '',
	orderQty: 0,
	cancelQty: 0,
	orderPrice: 0,
	dcAmt: 0,
	itemAmt: 0,
	remark: '',
	insertDt: new Date().toISOString(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date().toISOString(),
	updateUser: '',
	updateForm: '',

	itemNm: '',
	itemSpec: '',
	itemUnit: '',

	inserted: false,
	isModified: false,
};

export interface PUR1021_R01PurchaseDto extends BomDto {


	itemNo: string;
	moqQty: number;
	totalQty: number;
	stockQty: number;
	requiredPurchaseQty: number;
	
	modelNo: string;
	orderPrice: number;
	locationCd?: string;
	locationNm?: string;
}

export const defaultPUR1021_R01PurchaseDto: PUR1021_R01PurchaseDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	itemNo: '',
	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	bomSeq: 0,
	bomUseyn: 'Y',
	bomUpdateNo: '',
	prntItemQty: 0,
	prntItemUnit: '',
	childItemUsage: 0,
	childItemUnit: '',
	fixLossqty: 0,
	materialIntype: '',
	lossPercent: 0,
	remark: '',

	modelNo: '',
	orderPrice: 0,

	moqQty: 0,
	totalQty: 0,
	stockQty: 0,
	requiredPurchaseQty: 0,
	locationCd: '',
	locationNm: '',

	inserted: false,
	isModified: false,
}

export interface PUR1021_R01SuppliedDto extends BomDto {
	itemNo: string;
	orderPrice: number;

	moqQty: number;
	totalQty: number;
	stockQty: number;
	orderQty: number;
	locationCd?: string;
	locationNm?: string;
}

export const defaultPUR1021_R01SuppliedDto: PUR1021_R01SuppliedDto = {
	
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	itemNo: '',
	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	bomSeq: 0,
	bomUseyn: 'Y',
	bomUpdateNo: '',
	prntItemQty: 0,
	prntItemUnit: '',
	childItemUsage: 0,
	childItemUnit: '',
	fixLossqty: 0,
	materialIntype: '',
	lossPercent: 0,
	remark: '',
	
	orderPrice: 0,
	moqQty: 0,
	totalQty: 0,
	stockQty: 0,
	orderQty: 0,
	locationCd: '',
	locationNm: '',
	
	inserted: false,
	isModified: false,
}
